import { lazy, Route } from '@tanstack/router'

import { sponsorsRoute } from '.'

const SponsorsDetails = lazy(
  () => import('../../pages/sponsors/sponsors-details'),
)

export const sponsorsDetailsRoute = new Route({
  getParentRoute: () => sponsorsRoute,
  path: '$slug',
  component: SponsorsDetails,
})
